// extracted by mini-css-extract-plugin
export default {"copyIcon":"CopyToClipboardIcon_copyIcon__RpBpV","copyGroup":"CopyToClipboardIcon_copyGroup__7nwAN"};